import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { fontColors } from '../material-ui-theme';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    '& .MuiSvgIcon-root': {
      color: fontColors.grey,
    },
  },
}));

const ConjointArrows = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ArrowUpwardIcon fontSize="small" />
      <ArrowDownwardIcon fontSize="small" />
    </div>
  );
};

export default ConjointArrows;
